import { css } from 'styled-components';

/**
 * custom_antd.scss의 v3 크기/가상 손잡이와 v5 컨트롤의 충돌을 결제 화면에서만 보정한다.
 * 모달은 portal에 렌더링되므로 본문과 같은 스타일을 별도로 적용한다.
 */
export const settingsControlStyles = css`
  .ant-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    gap: 8px;
    height: 36px;
    padding: 0 16px;
    line-height: 1.4;
    font-size: 14px;
  }
  .ant-btn.ant-btn-sm {
    height: 32px;
    padding: 0 12px;
    font-size: 13px;
  }
  .ant-btn.ant-btn-icon-only {
    width: 36px;
    min-width: 36px;
    padding: 0;
  }
  .ant-btn.ant-btn-sm.ant-btn-icon-only {
    width: 32px;
    min-width: 32px;
  }
  .ant-btn .ant-btn-icon {
    display: inline-flex;
    align-items: center;
    margin: 0;
  }
  .ant-btn.ant-btn-text,
  .ant-btn.ant-btn-link {
    border-color: transparent;
    background: transparent;
    box-shadow: none;
  }
  .ant-btn.ant-btn-text:not(:disabled):hover {
    background: #f0ecfc;
  }
  .ant-btn:focus-visible,
  button:focus-visible {
    outline: 2px solid #7950f2;
    outline-offset: 3px;
  }

  .ant-switch {
    flex: 0 0 auto;
    min-width: 44px;
    width: 44px;
    height: 24px;
    line-height: 24px;
    border: 0;
    padding: 0;
  }
  .ant-switch .ant-switch-inner {
    margin: 0;
  }
  .ant-switch::after {
    content: none;
    display: none;
  }

  .ant-input-affix-wrapper {
    min-height: 36px;
    padding: 6px 12px;
  }
  input.ant-input {
    min-height: 36px;
    padding: 6px 12px;
  }
  .ant-input-affix-wrapper > input.ant-input {
    height: auto;
    min-height: 0;
    padding: 0;
  }
  textarea.ant-input {
    padding: 10px 12px;
    line-height: 1.6;
  }
  .ant-select-single,
  .ant-select-single .ant-select-selector,
  .ant-input-number,
  .ant-picker {
    min-height: 36px;
  }
  .ant-input-number-input {
    height: 34px;
    padding: 0 12px;
  }
  /*
   * 🔴 숫자 조절기(handler)는 쓰지 않는다 — 결제 화면의 InputNumber 는 전부 controls={false} 다.
   * 레거시 antd v3 전역 스타일(custom_antd.scss)이 핸들러를 불투명 배경으로 입력칸 위에
   * 겹쳐 그려서(position:absolute; right:0; background:#fff) hover 시 값이 가려진다.
   * 혹시 조절기를 켜는 입력이 생기면 이 규칙이 겹침을 막는다.
   */
  .ant-input-number:not(.ant-input-number-disabled) .ant-input-number-handler-wrap {
    display: none;
  }
  .ant-select-single .ant-select-selector {
    padding: 0 12px;
    align-items: center;
  }
  .ant-picker {
    padding: 6px 12px;
  }
`;
